import { REVIEWS, SITE } from "../data/site";
import { Star } from "lucide-react";

const ReviewCard = ({ name, text }) => (
  <article
    className="snap-start shrink-0 w-[88%] sm:w-[420px] bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-lg p-7 flex flex-col"
    data-testid={`review-${name.replace(/\s+/g, "-").toLowerCase()}`}
  >
    <div className="flex gap-0.5 mb-4 text-[hsl(var(--clay))]">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="w-4 h-4 fill-current" />
      ))}
    </div>
    <p className="text-[15px] leading-relaxed text-[hsl(var(--ink))]/85 flex-1">
      “{text}”
    </p>
    <p className="mt-5 font-display text-lg">{name}</p>
    <p className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))]">
      Google Review
    </p>
  </article>
);

const Reviews = () => {
  const half = Math.ceil(REVIEWS.length / 2);
  const rowA = REVIEWS.slice(0, half);
  const rowB = REVIEWS.slice(half);

  return (
    <section
      id="reviews"
      data-testid="reviews"
      className="py-20 md:py-28 bg-[hsl(var(--sand))]/40"
    >
      <div className="container-tjb">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="eyebrow">Loved in Bali</p>
            <h2 className="h-section mt-3">Loved by Bali Shoppers</h2>
            <p className="mt-4 max-w-xl text-base md:text-lg text-[hsl(var(--ink))]/80">
              Rated 5.0 on Google with 200+ reviews from customers who visited
              our stores in Canggu and Ubud.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={SITE.cangguMaps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-canggu-link"
              className="btn-outline"
            >
              Read Reviews — Canggu Store
            </a>
            <a
              href={SITE.ubudMaps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-ubud-link"
              className="btn-outline"
            >
              Read Reviews — Ubud Store
            </a>
          </div>
        </div>

        <div className="space-y-5">
          <div className="-mx-5 px-5 scroll-row" data-testid="reviews-row-1">
            {rowA.map((r) => (
              <ReviewCard key={r.name} {...r} />
            ))}
          </div>
          <div className="-mx-5 px-5 scroll-row" data-testid="reviews-row-2">
            {rowB.map((r) => (
              <ReviewCard key={r.name} {...r} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
